// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
let mmMobileMenuTrap = null;

const mmMobileMenu = () => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		mobileMenuSecondary: document.querySelector("[data-menu-sublinks]"),
		headerMenu: document.querySelector("[data-mm-header]"),
		html: document.querySelector("html"),
	};

	const { header, icon, mobileMenu, mobileMenuSecondary, headerMenu, html } = elements;

	const headerHeight = headerMenu.offsetHeight;
	const headerMenuTop = headerMenu.getBoundingClientRect().top;
	const topPosition = `${headerHeight + headerMenuTop}px`;
	const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

	[header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
	html.classList.toggle("stop-scrolling");

	Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });

	mobileMenuSecondary.style.height = heightCalc;

	// Focus trap logic
	const focusableElements = mobileMenu.querySelectorAll(
		'a[href], button:not([disabled]), textarea, input, select'
	);
	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	if (mmMobileMenuTrap) {
		mobileMenu.removeEventListener('keydown', mmMobileMenuTrap);
		mmMobileMenuTrap = null;
	}
	if (mobileMenu.classList.contains("mm-open")) {
		firstElement?.focus();
		mmMobileMenuTrap = createFocusTrap(firstElement, lastElement, mobileMenu);
		mobileMenu.addEventListener('keydown', mmMobileMenuTrap);
	}
};

const createFocusTrap = (firstElement, lastElement, menu) => (e) => {
	if (e.key === 'Escape') {
		mmCloseMobileMenu();
	}
	if (e.key !== 'Tab') return;

	if (e.shiftKey) {
		if (document.activeElement === firstElement) {
			e.preventDefault();
			lastElement.focus();
		}
	} else {
		if (document.activeElement === lastElement) {
			e.preventDefault();
			firstElement.focus();
		}
	}
};
/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;
	const wasOpen = mobileMenu.classList.contains("mm-open");

	[header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
	html.classList.remove("stop-scrolling");
	if (mmMobileMenuTrap) {
		mobileMenu.removeEventListener('keydown', mmMobileMenuTrap);
		mmMobileMenuTrap = null;
	}
	if (wasOpen) icon.querySelector('button[onclick^="mmMobileMenu"]')?.focus();
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll("[data-drop]");

	dropWrappers.forEach((item) => {
		if (item.dataset.dropdownHandled) return;
		item.dataset.dropdownHandled = true;

		const content = item.nextElementSibling;
		if (!content) return;

		const dropType = item.getAttribute("data-drop");
		const isActiveByDefault = dropType === "dropdown-active";

		// Initial state
		if (isActiveByDefault || item.classList.contains("active")) {
			item.classList.add("active");
			if (dropType !== "dropdown-2") {
				item.setAttribute("aria-expanded", "true");
			}
			content.style.maxHeight = `${content.scrollHeight}px`;
		} else {
			if (dropType !== "dropdown-2") {
				item.setAttribute("aria-expanded", "false");
				content.setAttribute("hidden", "");
			}
		}

		item.addEventListener("click", function () {
			const currentContent = this.nextElementSibling;
			if (!currentContent) return;

			const dropTypeClick = this.getAttribute("data-drop");
			const isActive = this.classList.contains("active");

			// Close other dropdowns
			if (!isActive && dropTypeClick !== "dropdown-2") {
				document.querySelectorAll("[data-drop]").forEach((el) => {
					if (el.getAttribute('data-drop') === 'dropdown-2') return;

					const otherContent = el.nextElementSibling;
					el.classList.remove("active");
					el.setAttribute("aria-expanded", "false");
					if (otherContent) {
						otherContent.style.maxHeight = null;
						otherContent.setAttribute("hidden", "");
						const focusable = otherContent.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
						focusable.forEach(f => f.setAttribute('tabindex', '-1'));
					}
				});
			}

			// Toggle this dropdown
			this.classList.toggle("active");
			const isNowActive = this.classList.contains("active");
			const focusableElements = currentContent.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
			
			if (dropTypeClick !== "dropdown-2") {
				this.setAttribute("aria-expanded", isNowActive.toString());
			}

			if (isNowActive) {
				focusableElements.forEach(el => el.removeAttribute('tabindex'));
				// Opening
				if (dropTypeClick !== "dropdown-2") {
					currentContent.removeAttribute("hidden");
				}
				requestAnimationFrame(() => {
					currentContent.style.maxHeight = `${currentContent.scrollHeight}px`;
				});

				// Use a timeout to refresh Splide after the animation
				setTimeout(() => {
					const splideElem = currentContent.querySelector('.splide');
					if (splideElem && splideElem.splide) {
						splideElem.splide.refresh();
					}
				}, 100); // A bit longer than the CSS transition

				const isChildDropdown = this.classList.contains("mm-actifs-ingredients-title");
				if (isChildDropdown) {
					const parentContent = this.closest(".mm-actifs-content-wrapper");
					if (parentContent) {
						const childHeight = currentContent.scrollHeight;
						parentContent.style.maxHeight = `${parentContent.scrollHeight + childHeight}px`;
					}
				}
			} else {
				focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
				// Closing
				currentContent.style.maxHeight = null;
				if (dropTypeClick !== "dropdown-2") {
					currentContent.addEventListener(
						"transitionend",
						() => {
							if (!this.classList.contains("active")) {
								currentContent.setAttribute("hidden", "");
							}
						},
						{ once: true }
					);
				}

				const isChildDropdown = this.classList.contains("mm-actifs-ingredients-title");
				if (isChildDropdown) {
					const parentContent = this.closest(".mm-actifs-content-wrapper");
					if (parentContent && currentContent) {
						const childHeight = currentContent.scrollHeight;
						parentContent.style.maxHeight = `${parentContent.scrollHeight - childHeight}px`;
					}
				}
			}
		});

		const closeDropdown = () => {
			if (!item.classList.contains("active")) return;
			item.classList.remove("active");
			if (dropType !== "dropdown-2") {
				item.setAttribute("aria-expanded", "false");
			}
			content.style.maxHeight = null;
			if (dropType !== "dropdown-2") {
				content.addEventListener(
					"transitionend",
					() => {
						if (!item.classList.contains("active")) {
							content.setAttribute("hidden", "");
						}
					},
					{ once: true }
				);
			}

			// Rendre le contenu non focusable
			const focusableElements = content.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
			focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
		};

		const checkFocus = () => {
			setTimeout(() => {
				if (!content.contains(document.activeElement) && document.activeElement !== item) {
					closeDropdown();
				}
			}, 10);
		};

		if (dropType !== "dropdown-2") {
			item.addEventListener("focusout", checkFocus);
			content.addEventListener("focusout", checkFocus);
		}

		// Gérer l'état initial pour la focusabilité
		if (!item.classList.contains("active")) {
			const focusableElements = content.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
			focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
		}
	});
};

// Rendre handleDropdown accessible globalement
window.handleDropdown = handleDropdown;
window.initAccordions = initAccordions;


/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
	const sections = document.querySelectorAll(`[${attributeName}]`);

	sections.forEach(function (section) {
		const splideElem = section.querySelector(className);

		if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
			// Appel dynamique de la fonction passée en paramètre
			initializeFunction(splideElem, section);
		}
	});
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
	let scrollCounter = 0;

	splideElem.addEventListener("wheel", function (e) {
		if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
			return;
		}

		e.preventDefault();

		scrollCounter++;

		if (scrollCounter >= 12) {
			scrollCounter = 0;

			if (e.deltaX < 0) {
				splideInstance.go("<");
			} else if (e.deltaX > 0) {
				splideInstance.go(">");
			}
		}
	});
}

/*********************************************************************************************
 * Fonction pour mettre à jour la progression
 */
function updateProgress(splideInstance, section) {
	var bar = section.querySelector('.mm-conseils-utilisations-progress-bar');
	if (bar) {
		splideInstance.on('mounted move', function () {
			var end = splideInstance.Components.Controller.getEnd() + 1;
			var rate = Math.min((splideInstance.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + '%';
		});
	}
}

/*********************************************************************************************
 * 🎠 SPLIDE MODULE
 */
const SplideManager = {
	init() {
		const splideElements = Array.from(document.querySelectorAll('.splide[data-splide]'));
		if (!splideElements.length || typeof Splide === 'undefined') return;

		let initializedCount = 0;
		const sectionsWithSplide = [];

		if (!document.documentElement.dataset.splideControlsBound) {
			document.addEventListener('click', (ev) => {
				const btn = ev.target && ev.target.closest && ev.target.closest('[data-splide-control]');
				if (!btn) return;
				ev.preventDefault();

				const action = (btn.dataset && btn.dataset.splideControl) || '';
				let targetElem = null;
				const targetSelector = btn.dataset && btn.dataset.splideTarget;
				if (targetSelector) targetElem = document.querySelector(targetSelector);

				const instance = targetElem && targetElem.splide;
				if (!instance) return;

				switch (action) {
					case 'prev': instance.go('<'); break;
					case 'next': instance.go('>'); break;
					default:
						if (action) { try { instance.go(action); } catch (e) {} }
				}
			}, { passive: false });

			document.documentElement.dataset.splideControlsBound = '1';
		}

		splideElements.forEach(element => {
			if (element.splide) return;

			const isProductMediaSlider = element.hasAttribute('data-main-slider') ||
										element.hasAttribute('data-thumbnail-slider');
			if (isProductMediaSlider) return;

			try {
				const configData = element.dataset.splide;
				let splideInstance;

				if (configData) {
					const config = JSON.parse(configData);

					// Loop mode: duplicate slides to ensure Splide has enough to clone.
					// Skip if the slider will be destroyed at the current viewport.
					let loopRealCount = null;
					if (config.type === 'loop') {
						const list = element.querySelector('.splide__list');
						if (list) {
							const slides = Array.from(list.children);
							loopRealCount = slides.length;

							const w = window.innerWidth;
							const activeBpKey = config.breakpoints
								? Object.keys(config.breakpoints).map(Number).sort((a, b) => a - b).find(bp => w <= bp)
								: undefined;
							const activeBpConfig = activeBpKey !== undefined ? config.breakpoints[activeBpKey] : null;
							const effectiveDestroy = activeBpConfig && activeBpConfig.destroy !== undefined
								? activeBpConfig.destroy
								: (config.destroy || false);

							if (!effectiveDestroy && loopRealCount > 0 && loopRealCount < 8) {
								const times = Math.ceil(8 / loopRealCount) - 1;
								const html = slides.map(s => s.outerHTML).join('');
								for (let i = 0; i < times; i++) {
									list.insertAdjacentHTML('beforeend', html);
								}
							}
						}
					}

					splideInstance = new Splide(element, config).mount();
					element.splide = splideInstance;
					element.classList.remove('mm-splide-pending');

					// Sync custom pagination by watching is-active on slides directly
					const customPagination = element.querySelector('.mm-bandeau-pagination');
					if (customPagination && loopRealCount) {
						const dots = Array.from(customPagination.querySelectorAll('button'));

						const updateDots = () => {
							const realSlides = Array.from(element.querySelectorAll('.splide__slide:not(.splide__slide--clone)'));
							const activeIdx = realSlides.findIndex(s => s.classList.contains('is-active'));
							if (activeIdx === -1) return;
							const realIndex = activeIdx % loopRealCount;
							dots.forEach((btn, i) => btn.classList.toggle('is-active', i === realIndex));
						};

						dots.forEach((btn, i) => {
							btn.addEventListener('click', () => splideInstance.go(i));
						});

						const observer = new MutationObserver(updateDots);
						element.querySelectorAll('.splide__slide').forEach(slide => {
							observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
						});

						updateDots();
					}
				} else {
					splideInstance = new Splide(element).mount();
					element.splide = splideInstance;
					element.classList.remove('mm-splide-pending');
				}

				const images = element.querySelectorAll('img');
				if (images.length > 0) {
					let loadedCount = 0;
					const totalImages = images.length;
					const checkAllImagesLoaded = () => {
						loadedCount++;
						if (loadedCount === totalImages && splideInstance) {
							requestAnimationFrame(() => { splideInstance.refresh(); });
						}
					};
					images.forEach(img => {
						if (img.complete) { checkAllImagesLoaded(); }
						else {
							img.addEventListener('load', checkAllImagesLoaded, { once: true });
							img.addEventListener('error', checkAllImagesLoaded, { once: true });
						}
					});
				}

				const progressBar = element.querySelector('.splide__progress__bar');
				if (progressBar && splideInstance) {
					const updateProgressBar = function() {
						try {
							const end = splideInstance.Components.Controller.getEnd() + 1;
							const rate = Math.min((splideInstance.index + 1) / end, 1);
							progressBar.style.width = String(100 * rate) + '%';
						} catch (error) {}
					};
					splideInstance.on('mounted ready', updateProgressBar);
					splideInstance.on('move moved', updateProgressBar);
					requestAnimationFrame(() => { setTimeout(updateProgressBar, 50); });
				}

				if (splideInstance) {
					const candidates = document.querySelectorAll('[data-splide-control][data-splide-target]');
					const controls = Array.from(candidates).filter((btn) => {
						const sel = btn.dataset && btn.dataset.splideTarget;
						if (!sel) return false;
						try { return document.querySelector(sel) === element; } catch (e) { return false; }
					});

					if (controls.length) {
						const prevBtns = controls.filter((b) => (b.dataset.splideControl || '').toLowerCase() === 'prev');
						const nextBtns = controls.filter((b) => (b.dataset.splideControl || '').toLowerCase() === 'next');
						const updateExternalArrows = () => {
							try {
								const isLoop = (splideInstance.options && splideInstance.options.type === 'loop') || false;
								const end = splideInstance.Components.Controller.getEnd();
								prevBtns.forEach((btn) => { btn.disabled = !isLoop && splideInstance.index <= 0; });
								nextBtns.forEach((btn) => { btn.disabled = !isLoop && splideInstance.index >= end; });
							} catch (e) {}
						};
						splideInstance.on('mounted move moved updated', updateExternalArrows);
						requestAnimationFrame(updateExternalArrows);
					}
				}

				const sectionElement = element.closest('section');
				if (sectionElement) {
					const sectionName = sectionElement.className || 'unnamed-section';
					if (!sectionsWithSplide.includes(sectionName)) sectionsWithSplide.push(sectionName);
				}

				initializedCount++;

			} catch (error) {
				console.error('SplideManager: JSON parsing failed for element:', element.className);
				console.error('SplideManager: data-splide:', element.dataset.splide);
				try {
					const fallback = new Splide(element).mount();
					element.splide = fallback;
					initializedCount++;
				} catch (fallbackError) {
					console.error('SplideManager: Fallback initialization failed:', fallbackError.message);
				}
			}
		});

		if (initializedCount > 0) {
			document.dispatchEvent(new CustomEvent('global:splide-initialized', {
				detail: { count: initializedCount, sections: sectionsWithSplide }
			}));
		}
	}
};

/*********************************************************************************************
 * Fonction pour gérer les variantes de produits
 */
const handleFreeProductFormVariant = () => {
	document.querySelectorAll(".mm-variant").forEach((form) => {
		const selector = form.querySelector(".variant-selector");
		const link = form.querySelector(".variant-link");

		if (selector && link) {
			selector.addEventListener("change", function () {
				link.setAttribute("href", this.value);
			});
		}
	});
};

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	documentHeight();
	handleDropdown();
	handleFreeProductFormVariant();
	SplideManager.init();

	const setupEnterToClick = (containerSelector, clickTargetSelector) => {
		const container = document.querySelector(containerSelector);
		if (container) {
			container.addEventListener("keydown", function (event) {
				if (event.key === "Enter") {
					event.preventDefault();
					const target = container.querySelector(clickTargetSelector);
					if (target) {
						target.click();
					}
				}
			});
		}
	};

	setupEnterToClick(".mm-product-form-recharge-once", ".mm-product-form-recharge-once-input");
	setupEnterToClick(".mm-product-form-recharge-abonnement", ".mm-product-form-recharge-abonnement-input");
	setupEnterToClick(
		".mm-product-form-recharge-abonnement-reassurance",
		'[data-drop="dropdown"]'
	);
});

/*********************************************************************************************
 * Theme editor Listenner
 *
 */
document.addEventListener("shopify:section:load", () => {
	handleDropdown();
	SplideManager.init();
});

document.addEventListener("shopify:section:unload", (event) => {
	event.target.querySelectorAll(".splide").forEach((element) => {
		if (element.splide) element.splide.destroy();
	});
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener("resize", () => {
	documentHeight();
});

// -------------------------------------------------------------------------------------------
// Egalisation de la hauteur des logos d'articles par ligne
// -------------------------------------------------------------------------------------------
/**
 * Debounce utilitaire pour limiter la fréquence d'exécution.
 * @param {Function} func
 * @param {number} wait
 * @returns {Function}
 */
function mmDebounce(func, wait) {
	let timeoutId;
	return function () {
		const context = this;
		const args = arguments; // eslint-disable-line prefer-rest-params
		clearTimeout(timeoutId);
		timeoutId = setTimeout(function () {
			func.apply(context, args);
		}, wait);
	};
}

/**
 * Egalise la hauteur des éléments .mm-card-article-logo sur chaque ligne d'une grille.
 * La comparaison se fait via offsetTop afin de regrouper par lignes visibles.
 */
function mmEqualizeArticleLogos() {
	const grids = document.querySelectorAll('.mm-article-grid');
	if (!grids.length) return;

	grids.forEach(function (grid) {
		// S'assurer que chaque carte a un conteneur de logo (placeholder si absent)
		grid.querySelectorAll('.mm-card-article').forEach(function(card){
			if (!card.querySelector('.mm-card-article-logo')) {
				const placeholder = document.createElement('p');
				placeholder.className = 'mm-card-article-logo title-s mm-w-fit mm-text-center mm-flex mm-align-center';
				card.insertBefore(placeholder, card.firstElementChild || null);
			}
		});

		// Réinitialiser d'abord les hauteurs pour recalcul propre
		grid.querySelectorAll('.mm-card-article-logo').forEach(function (el) {
			el.style.minHeight = '';
		});

		// Regrouper par ligne basé sur la position verticale des cartes
		const gridTop = grid.getBoundingClientRect().top;
		const cards = Array.from(grid.querySelectorAll('.mm-card-article'));
		const rowsMap = new Map();
		cards.forEach(function(card){
			const relTop = Math.round(card.getBoundingClientRect().top - gridTop);
			const logo = card.querySelector('.mm-card-article-logo');
			if (!logo) return;
			if (!rowsMap.has(relTop)) rowsMap.set(relTop, []);
			rowsMap.get(relTop).push(logo);
		});
		rowsMap.forEach(function(rowLogos){
			const max = rowLogos.reduce(function (acc, el) { return Math.max(acc, el.offsetHeight); }, 0);
			rowLogos.forEach(function (el) { el.style.minHeight = max + 'px'; });
		});
	});
}

/**
 * Installe des observateurs pour relancer l'égalisation dès que la grille change
 * (resize, mutations DOM, images chargées).
 */
function mmInstallArticleLogoObservers() {
	const grids = document.querySelectorAll('.mm-article-grid');
	if (!grids.length) return;

	const debounced = mmDebounce(mmEqualizeArticleLogos, 50);

	grids.forEach(function (grid) {
		if (grid.__mmLogoObsInstalled) return;
 
 		// Observer redimensionnements du conteneur
 		if (window.ResizeObserver) {
 			const ro = new ResizeObserver(function () { debounced(); });
 			ro.observe(grid);
 			grid.__mmLogoResizeObserver = ro;
 		}

 		// Observer mutations (ajout/retrait/modif des cartes)
 		if (window.MutationObserver) {
 			const mo = new MutationObserver(function () { debounced(); });
 			mo.observe(grid, { childList: true, subtree: true });
 			grid.__mmLogoMutationObserver = mo;
 		}

 		// Observer chargement des images
 		grid.querySelectorAll('img').forEach(function (img) {
 			if (!img.complete) {
 				img.addEventListener('load', debounced, { once: true });
 			}
 		});

 		grid.__mmLogoObsInstalled = true;
 	});
}

// Appels au chargement (après DOM + après chargement des polices si dispo)
document.addEventListener('DOMContentLoaded', function () {
	// Exécution immédiate et installation des observateurs
	mmEqualizeArticleLogos();
	mmInstallArticleLogoObservers();
});

// Appel au redimensionnement avec debounce
window.addEventListener('resize', mmDebounce(mmEqualizeArticleLogos, 150));

// Recalcule final quand tout (images, fonts hors promises) est chargé
window.addEventListener('load', function(){ mmEqualizeArticleLogos(); mmInstallArticleLogoObservers(); });

// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

/* Accordions */
function initAccordions() {
	const toggles = document.querySelectorAll("[data-accordion-toggle]");

	toggles.forEach((toggle) => {
		if (toggle.dataset.accordionBound) return;
		toggle.dataset.accordionBound = true;
		toggle.setAttribute("aria-expanded", String(toggle.classList.contains("mm-open")));

		toggle.addEventListener("click", function () {
			const targetId = toggle.getAttribute("data-accordion-toggle");
			const content = document.querySelector(`[data-accordion-content="${targetId}"]`);
			if (!content) return;

			// Toggle class sur le bouton
			toggle.classList.toggle("mm-open");
			toggle.setAttribute("aria-expanded", String(toggle.classList.contains("mm-open")));

			// Toggle hauteur contenu
			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	});

	// Si vous avez des éléments à ouvrir au chargement
	const elemsToOpenOnLoad = document.querySelectorAll("[data-open-on-load]");
	elemsToOpenOnLoad.forEach(function (toggle) {
		if (toggle.dataset.openOnLoadHandled) return;
		toggle.dataset.openOnLoadHandled = "true";

		const targetId = toggle.getAttribute("data-accordion-toggle");
		const content = document.querySelector(`[data-accordion-content="${targetId}"]`);
		if (content) {
			toggle.classList.add("mm-open");
			toggle.setAttribute("aria-expanded", "true");
			content.style.maxHeight = content.scrollHeight + "px";
			// Supprimer la classe pour permettre les animations futures lors des clics manuels
			setTimeout(() => {
				content.classList.remove("mm-no-animation");
			}, 100);
		}
	});
}

// Consolidation des écouteurs DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
    // Retarder les initialisations non critiques
    setTimeout(() => {
        initAccordions();
    }, 200);
});

// Lazy loading pour les images avec data-src
document.addEventListener("DOMContentLoaded", function () {
	const lazyImages = document.querySelectorAll("img.lazy[data-src]");

	if ("IntersectionObserver" in window) {
		const imageObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const img = entry.target;
					img.src = img.dataset.src;
					img.classList.remove("lazy");
					img.removeAttribute("data-src");
					imageObserver.unobserve(img);
				}
			});
		});

		lazyImages.forEach((img) => imageObserver.observe(img));
	} else {
		// Fallback pour les navigateurs qui ne supportent pas IntersectionObserver
		lazyImages.forEach((img) => {
			img.src = img.dataset.src;
			img.classList.remove("lazy");
			img.removeAttribute("data-src");
		});
	}
});

// Script simple pour copier l'URL
document.addEventListener("DOMContentLoaded", function () {
	const copyButton = document.getElementById("copy-link");

	if (copyButton) {
		copyButton.addEventListener("click", function () {
			navigator.clipboard.writeText(window.location.href);
		});
	}
});


// Correction du décalage de l'ancre au chargement (Scroll offset fix)
window.addEventListener('load', function() {
	if (window.location.hash) {
		setTimeout(function() {
			const target = document.querySelector(window.location.hash);
			const header = document.querySelector('header');
			
			if (target) {
				const headerHeight = header ? header.offsetHeight : 0;
				const targetPosition = target.getBoundingClientRect().top + window.scrollY;
				// On soustrait la hauteur du header et un peu d'espace (20px)
				const offsetPosition = targetPosition - headerHeight - 20;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		}, 500); // Délai de 500ms pour être sûr que tout est chargé
	}
});